(function (Drupal) {
  Drupal.behaviors.alertMessages = {
    attach: function (context, settings) {
      const alerts = context.querySelectorAll(".alert");

      alerts.forEach((alert) => {
        if (!alert.dataset.alertProcessed) {
          alert.dataset.alertProcessed = "true";

          const closeButton = alert.querySelector(".close");
          if (closeButton) {
            closeButton.addEventListener("click", function (e) {
              e.preventDefault();
              alert.style.transition =
                "max-height 0.2s ease, opacity 0.2s ease";
              alert.style.maxHeight = "0";
              alert.style.opacity = "0";

              setTimeout(() => {
                alert.style.display = "none";
              }, 200);
            });
          }
        }
      });
    },
  };
})(Drupal);
